
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-quicktor",
      function () {
        return require("private-next-pages/about-quicktor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-quicktor"])
      });
    }
  